import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
/**
 * Prime Ng Module
 */
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule as pNgDropdownModule } from 'primeng/dropdown';
import { GalleriaModule } from 'primeng/galleria';
import { InputNumberModule as PrimeInputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SidebarModule } from 'primeng/sidebar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { TreeTableModule } from 'primeng/treetable';
import { CalendarModule } from 'primengv15/calendar';
import { CheckboxModule } from 'primengv15/checkbox';

//common components
import { AddressSelectorComponent } from './components/address-selector/address-selector.component';
import { AutoCompleteComponent } from './components/auto-complete/auto-complete.component';
import { BottomPanelComponent } from './components/bottom-panel/bottom-panel.component';
import { BpmBatchButtonGroupComponent } from './components/bpm-batch-button-group/bpm-batch-button-group.component';
import { BpmButtonGroupComponent } from './components/bpm-button-group/bpm-button-group.component';
import { ContentDialogComponent } from './components/content-dialog/content-dialog.component';
// import { CurrencyComponent } from './components/currency/currency.component';
import { DataTableComponent } from './components/data-table/data-table.component';
import { FormControlWidgetComponent } from './components/form-control-widget/form-control-widget.component';
import { TextAreaComponent } from './components/text-area/text-area.component';

import { BpmButtonDef } from '../core/models/bpm-button-def';
import { BpmButtonDefBuilderService } from '../core/services/bpm-button-def-builder.service';
import { DropdownModule } from '../rt-shared/ui/dropdown/dropdown.module';
import { VisitedLinkModule } from '../rt-shared/ui/visited-link/visited-link.module';

import { ButtonGroupComponent } from './components/button-group/button-group.component';
import { CifnoSearchComponent } from './components/cifno-search/cifno-search.component';
import { CollapsibleContentContainerComponent } from './components/collapsible-content-container/collapsible-content-container.component';
import { CurrencyWidgetComponent } from './components/currency-widget/currency-widget.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DateRangePickerComponent } from './components/date-range-picker/date-range-picker.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { HintDialogContainerComponent } from './components/hint-dialog-container/hint-dialog-container.component';
import { HistoryRadiogroupComponent } from './components/history-radiogroup/history-radiogroup.component';
import { QueryFormContainerComponent } from './components/query-form-container/query-form-container.component';
import { RemarkWidgetComponent } from './components/remark-widget/remark-widget.component';
import { SchedulePlannerComponent } from './components/schedule-planner/schedule-planner.component';
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { StaffSelectorComponent } from './components/staff-selector/staff-selector.component';
import { CustomButtonDirective } from './directives/button.directive';
import { CalendarInputMaskDirective } from './directives/calendar-input-mask.directive';
import { CalendarTimeConfirmationDirective } from './directives/calendar-time-confirmation.directive';
import { DetectDefaultValueDifferenceDirective } from './directives/detect-default-value-difference-directive.directive';
import { DetectDifferenceDirective } from './directives/detect-difference.directive';
import { ElementControlDirective } from './directives/element-control.directive';
import { InputNumberSettingDirective } from './directives/input-number-setting.directive';
import { PhoneNumberCheckDirective } from './directives/phone-number-check.directive';
import { CounterMaximumPipe } from './pipes/counter-maximum.pipe';
import { DatePipe } from './pipes/date.pipe';
import { DealerNamePipe } from './pipes/dealer-name.pipe';
import { DepartmentNamePipe } from './pipes/department-name.pipe';
import { EnumOptionsMappingPipe } from './pipes/enum-options-mapping.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { ImageUrlPipe } from './pipes/image-url.pipe';
import { MultiOptionsMappingPipe } from './pipes/multi-options-mapping.pipe';
import { OptionsMappingPipe } from './pipes/options-mapping.pipe';
import { ReplaceNullWithPipe } from './pipes/replace-null-with.pipe';
import { UserComposerPipe } from './pipes/user-composer.pipe';
import { UserDisplayNamePipe } from './pipes/user-display-name.pipe';
import { UserNoToDepartmentNamePipe } from './pipes/userNo-to-department.pipe';

const primeNgModule = [
  AccordionModule,
  AutoCompleteModule,
  BadgeModule,
  ButtonModule,
  BlockUIModule,
  CalendarModule,
  CheckboxModule,
  TreeTableModule,
  CardModule,
  DialogModule,
  DividerModule,
  pNgDropdownModule,
  GalleriaModule,
  InputTextModule,
  InputTextareaModule,
  PrimeInputNumberModule,
  MultiSelectModule,
  PanelMenuModule,
  ProgressSpinnerModule,
  RadioButtonModule,
  SidebarModule,
  SplitButtonModule,
  TableModule,
  TabViewModule,
  TooltipModule,
  ToastModule,
  // OverlayPanelModule,
  // PanelModule,
  // CardModule,
  // DataViewModule,
  // StepsModule,
  // PickListModule,
  // AvatarModule,
  // AvatarGroupModule,
  // MessagesModule,
  // MessageModule,
  // ScrollTopModule,
  // BreadcrumbModule,
  // SplitButtonModule,
  // TreeModule,
  // MenuModule,
  // TreeTableModule,
];
const modules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  //rt shared
  DropdownModule,
  VisitedLinkModule,
];
const components = [
  AddressSelectorComponent,
  AutoCompleteComponent,
  BpmButtonGroupComponent,
  BottomPanelComponent,
  ButtonGroupComponent,
  BpmBatchButtonGroupComponent,
  CifnoSearchComponent,
  CollapsibleContentContainerComponent,
  ContentDialogComponent,
  CurrencyWidgetComponent,
  DatePickerComponent,
  DateRangePickerComponent,
  DataTableComponent,
  FileUploadComponent,
  FormControlWidgetComponent,
  HintDialogContainerComponent,
  HistoryRadiogroupComponent,
  QueryFormContainerComponent,
  RemarkWidgetComponent,
  SchedulePlannerComponent,
  SideBarComponent,
  StaffSelectorComponent,
  TextAreaComponent,
];
const pipes = [
  ReplaceNullWithPipe,
  OptionsMappingPipe,
  EnumOptionsMappingPipe,
  CounterMaximumPipe,
  FileSizePipe,
  UserComposerPipe,
  DatePipe,
  ImageUrlPipe,
  UserDisplayNamePipe,
  DepartmentNamePipe,
  DealerNamePipe,
  MultiOptionsMappingPipe,
  UserNoToDepartmentNamePipe,
];
const directives = [
  CalendarTimeConfirmationDirective,
  CalendarInputMaskDirective,
  DetectDifferenceDirective,
  ElementControlDirective,
  InputNumberSettingDirective,
  PhoneNumberCheckDirective,
  DetectDefaultValueDifferenceDirective,
  CustomButtonDirective,
];
function createBpmButtonDefBuilder(
  buttonDefs: BpmButtonDef[]
): BpmButtonDefBuilderService {
  const defs: BpmButtonDef[] =
    buttonDefs.length > 0
      ? buttonDefs
      : [
          { displayName: 'Edit', action: 'Edit', priority: 0, order: 0 },
          { displayName: 'Release', action: 'Release', priority: 0, order: 0 },
          { displayName: 'Submit', action: 'Submit', priority: 0, order: 1 },
          { displayName: 'Submit', action: 'Approve', priority: 0, order: 1 },
          {
            displayName: 'Submit',
            action: 'ApplyWithdraw',
            priority: 0,
            order: 1,
          },
          {
            displayName: 'Submit',
            action: 'ApproveWithdraw',
            priority: 0,
            order: 1,
          },
          {
            displayName: 'Previous Version',
            action: 'PreviousVersion',
            priority: 0,
            order: 1,
          },
          {
            displayName: 'Copy',
            action: 'Copy',
            priority: 1,
            order: 1,
          },
          {
            displayName: 'Copy2',
            action: 'Copy2',
            priority: 0,
            order: 0,
          },
          { displayName: 'Save', action: 'Save', priority: 0, order: 2 },
          // CMN-FN021 評分表複製
          // {
          //   displayName: 'Duplicate',
          //   action: 'Duplicate',
          //   priority: 1,
          //   order: 1,
          // },
          { displayName: 'Cancel', action: 'Cancel', priority: 1, order: 2 },
          {
            displayName: 'ConfirmCancel',
            action: 'ConfirmCancel',
            priority: 1,
            order: 0,
          },
          { displayName: 'Return', action: 'Return', priority: 1, order: 3 },
          { displayName: 'Reject', action: 'Reject', priority: 1, order: 4 },
          {
            displayName: 'Reject',
            action: 'RejectWithdraw',
            priority: 1,
            order: 2,
          },
          { displayName: 'Discard', action: 'Discard', priority: 1, order: 0 },
          {
            displayName: 'CancelReceipt',
            action: 'CancelReceipt',
            priority: 1,
            order: 0,
          },
          { displayName: 'Print', action: 'Print', priority: 2, order: 0 },
          { displayName: 'Export', action: 'Export', priority: 2, order: 1 },
          {
            displayName: 'Attachment',
            action: 'Attachment',
            priority: 2,
            order: 2,
          },
          {
            displayName: 'Tracking Records',
            action: 'Records',
            priority: 2,
            order: 3,
          },
          {
            displayName: 'Supplement Initiation',
            action: 'SupplementInitiation',
            priority: 0,
            order: 3,
          },
          {
            displayName: 'Supplement Upload',
            action: 'SupplementUpload',
            priority: 0,
            order: 3,
          },
          {
            displayName: 'View Version History',
            action: 'ViewVersionHistory',
            priority: 0,
            order: 3,
          },
          { displayName: 'Back', action: 'Back', priority: 2, order: 999 },
        ];
  const service = new BpmButtonDefBuilderService();
  service.buttonDefs = defs;

  return service;
}
const bpmButtonBuilder = createBpmButtonDefBuilder([]);
@NgModule({
  declarations: [...components, ...pipes, ...directives],
  imports: [...modules, ...primeNgModule],
  exports: [...components, ...pipes, ...directives, ...primeNgModule],
  providers: [
    DecimalPipe,
    {
      provide: 'BpmButtonDefBuilder',
      useValue: bpmButtonBuilder,
    },
  ],
})
export class SharedModule {}
